import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.bc{align-items:start;}.ssr-plugin'
import { FC, useState } from 'react'
import { styled } from 'inlines'
import { Text } from './Text'
import { useTheme } from '../providers/useTheme'

export type ExpandableTextProps = {
  visibleContent?: string
  hiddenContent?: string
  label?: string[]
}

export const ExpandableText: FC<ExpandableTextProps> = ({
  visibleContent = '',
  hiddenContent = '',
  label = [''],
}) => {
  const [hiddenContentVisible, setHiddenContentVisible] = useState(true)
  const { colors } = useTheme()

  return (
    <div className="a i h bc"
    >
      <Text
        isMultiline
        variant="subheading-regular"
        color={colors.textSecondary}
      >
        {visibleContent}
      </Text>

      {hiddenContentVisible && hiddenContent && (
        <Text
          isMultiline
          variant="subheading-regular"
          color={colors.textSecondary}
        >
          {hiddenContent}
        </Text>
      )}

      {/* <Button
        id="expandable-text"
        isRaw
        label={hiddenContentVisible ? label[1] + ' ↑' : label[0] + ' ↓'}
        color={colors.primaryAccent}
        on={{
          click: () => setHiddenContentVisible(!hiddenContentVisible),
        }}
        style={{ marginTop: 16 }}
      /> */}
    </div>
  )
}
